import React from 'react'

import { UserType } from 'types/user'

import { PressableUserRow } from './subcomponents/PressableUserRow'

interface UserRowProps {
  user: UserType
  count?: number
  onUserPress?: (user: UserType) => void
}

export const UserRow = ({ user, count, onUserPress }: UserRowProps) => {
  return <PressableUserRow user={user} sessionsCompletedCount={count} onUserPress={onUserPress} />
}
